import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { PropertyManager, useInvalidatePropertyManagers } from './get-property-managers'

export type CreatePropertyManagerRequest = {
  avatar?: File
  buildingIds: number[]
  email: string
  firstName: string
  jobTitle?: string
  lastName: string
  password?: string
  phone?: string
}

export const createPropertyManager = async (data: CreatePropertyManagerRequest) => {
  const response = await authAPI.post<PropertyManager>('/propertyManager', composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useCreatePropertyManager = () => {
  const invalidatePropertyManagers = useInvalidatePropertyManagers()

  return useMutation({
    mutationFn: createPropertyManager,
    onSuccess: invalidatePropertyManagers,
  })
}
